module.exports = __webpack_public_path__ + "static/media/carte-verte-sans.4c5fb2e3.png";